import { Component, Input } from '@angular/core';
import { AdPlacementRoadOccupationFormValue } from '../../forms/ad-placement-road-occupation.form';
import {
  LocationDecisionsPreviewComponent
} from '../../../../../common/components/location-decisions/location-decisions-preview/location-decisions-preview.component';
import { DatePipe } from '@angular/common';
import { LabelComponent } from '../../../../../../../../common/label/label.component';
import {
  ParcelsPreviewComponent
} from '../../../../../common/components/parcels/parcels-preview/parcels-preview.component';

@Component({
  selector: 'app-ad-placement-occupation-preview',
  standalone: true,
  imports: [
    LocationDecisionsPreviewComponent,
    DatePipe,
    LabelComponent,
    ParcelsPreviewComponent
  ],
  templateUrl: './ad-placement-occupation-preview.component.html'
})
export class AdPlacementOccupationPreviewComponent {

  @Input()
  public occupation: AdPlacementRoadOccupationFormValue | undefined;
}
